import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const switchVariants = cva(
  `peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-green-300 data-[state=unchecked]:bg-input`,
  {
    variants: {
      size: {
        default: `h-6 w-11`,
        small: `h-4 w-7`,
      },
    },
    defaultVariants: {
      size: `default`,
    },
  }
)

type SwitchProps = React.ComponentPropsWithRef<typeof SwitchPrimitives.Root> &
  VariantProps<typeof switchVariants>

const Switch = ({
  ref,
  className,
  size = `default`,
  ...props
}: SwitchProps) => (
  <SwitchPrimitives.Root
    className={cn(switchVariants({ size }), className)}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        `pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0`,
        {
          "h-3 w-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0":
            size === `small`,
          "h-5 w-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0":
            size === `default`,
        }
      )}
    />
  </SwitchPrimitives.Root>
)
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch, switchVariants }
